module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Ultralight.461f2f5.otf";